import apiSlice from '../api/api.slice';
import { IUser } from '../auth/auth';

const followApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    followUser: builder.mutation<{ status: string }, string>({
      query: (targetUserId) => ({
        url: `/api/v1/follow/${targetUserId}`,
        method: 'POST',
      }),
      invalidatesTags: ['User', 'Follow'],
    }),
    unfollowUser: builder.mutation<{ status: string }, string>({
      query: (targetUserId) => ({
        url: `/api/v1/follow/${targetUserId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['User', 'Follow'],
    }),
    getFollowers: builder.query<
      IUser[],
      { targetUserId: string; page?: number; limit?: number }
    >({
      query: ({ targetUserId, page = 1, limit = 20 }) => ({
        url: `/api/v1/follow/${targetUserId}/followers`,
        method: 'GET',
        params: { page, limit },
      }),
      transformResponse: (response: { followers: IUser[] }) =>
        response.followers,
      providesTags: ['Follow'],
    }),
    getFollowing: builder.query<
      IUser[],
      { targetUserId: string; page?: number; limit?: number }
    >({
      query: ({ targetUserId, page = 1, limit = 20 }) => ({
        url: `/api/v1/follow/${targetUserId}/following`,
        method: 'GET',
        params: { page, limit },
      }),
      transformResponse: (response: { following: IUser[] }) =>
        response.following,
      providesTags: ['Follow'],
    }),
  }),
});

export const {
  useFollowUserMutation,
  useUnfollowUserMutation,
  useGetFollowersQuery,
  useGetFollowingQuery,
} = followApiSlice;
